module.exports = __webpack_public_path__ + "static/media/manta_ray_thumb.28c6c652.jpg";